import { Navbar as FbNavbar, NavbarBrand } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import UserProfileMenu from 'src/components/admin/navigation/userProfileMenu';
import { useSiteConfig } from 'src/contexts/SiteGuardContext';
import { twMerge } from 'tailwind-merge';
import { routePaths } from 'utils/constants';
import AppImage from 'components/image/AppImage';

type TopNavbarProps = {
   className?: string;
   darkMode?: boolean;
};

const TopNavbar: React.FC<TopNavbarProps> = ({ className }) => {
   const [_t] = useTranslation();
   const { siteConfig } = useSiteConfig();

   const aboutUrl = siteConfig?.visualBranding?.legal?.aboutUrl || '/about';
   const whoWeAreUrl = siteConfig?.visualBranding?.legal?.whoWeAreUrl || '/who-we-are';
   const aboutLabel = siteConfig?.visualBranding?.legal?.aboutLabel || 'About';
   const whoWeAreLabel = siteConfig?.visualBranding?.legal?.whoWeAreLabel || 'Who We Are';

   return (
      <FbNavbar
         fluid
         rounded={false}
         className={twMerge('bg-primary w-full px-3.75 sm:px-7.5 py-3.75 top-0 z-50', className)}
         theme={{
            root: {
               base: 'bg-primary border-none',
            },
         }}
      >
         {/* Brand logo */}
         <NavbarBrand href={routePaths.LANDING}>
            <AppImage
               alt={`${siteConfig?.displayName || 'Nonprofit Trips'} logo`}
               className="h-10 md:h-10"
               src={siteConfig?.visualBranding?.primaryLightLogo ?? siteConfig?.visualBranding?.primaryLogo}
            />
         </NavbarBrand>

         <div className="flex items-center gap-6 w-full justify-end md:w-auto">
            {/* Navigation links */}
            <a
               href={aboutUrl}
               className="text-white hover:text-white/80 focus:text-white focus:ring-2 focus:ring-white/50 focus:outline-none transition-colors duration-200 font-medium"
            >
               {aboutLabel}
            </a>
            <a
               href={whoWeAreUrl}
               className="text-white hover:text-white/80 focus:text-white focus:ring-2 focus:ring-white/50 focus:outline-none transition-colors duration-200 font-medium"
            >
               {whoWeAreLabel}
            </a>

            {/* User menus */}
            <UserProfileMenu darkMode={true} />
         </div>
      </FbNavbar>
   );
};

export default TopNavbar;
